// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerImg":"Footer_footerImg__z2UJk"};